import React from 'react';
import {
    Form,
    Checkbox,
    Row,
    Col,
    Space,
    Typography,
    Divider,
    Radio,
    Input,
} from 'antd';
import { AppstoreAddOutlined, ToolOutlined, HeartOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { getIcon } from '../utils/iconMap';

const { Title, Text } = Typography;
const { TextArea } = Input;

const ResourcesCustomization = ({ contentTypes, options, isOnlineMode }) => {

    // --- Logic from Resources.js ---
    const { instructional = [], practice = [], assessment = [] } = contentTypes || {};

    // --- Logic from Customization.js ---
    const {
        classroomFormat = [],
        classroomResources = [],
        assessmentOptions = [],
        wellBeingOptions = []
    } = options || {};

    return (
        <Space orientation="vertical" style={{ width: '100%' }} size="large">
            {/* --- START: Content from Resources.js (Layout Updated) --- */}
            <Title level={5}><AppstoreAddOutlined /> Resources</Title>
            <Form.Item
                name="selectedResources"
                rules={[{ required: true, message: 'Please select at least one resource.' }]}
            >
                <Checkbox.Group style={{ width: '100%' }}>
                    {/* --- MODIFICATION: Changed size from 'middle' to 'small' --- */}
                    <Space orientation="vertical" size="small" style={{ width: '100%' }}>
                        <div>
                            <Title level={5}>Instructional Resources</Title>
                            <Row gutter={[8, 16]}>{instructional.map((item) => (
                                <Col xs={24} sm={12} md={8} key={item.value}>
                                    <Checkbox value={item.value}>
                                        <Space>{getIcon(item.icon)}{item.label}</Space>
                                    </Checkbox>
                                </Col>
                            ))}</Row>
                        </div>
                        {/* --- MODIFICATION: Added compact margin to Divider --- */}
                        <Divider style={{ margin: '8px 0' }} />
                        <div>
                            {/* --- MODIFICATION: Removed top margin from Title --- */}
                            <Title level={5} style={{ marginTop: 0 }}>Practice Activities</Title>
                            <Row gutter={[8, 16]}>{practice.map((item) => (
                                <Col xs={24} sm={12} md={8} key={item.value}>
                                    <Checkbox value={item.value}>
                                        <Space>{getIcon(item.icon)}{item.label}</Space>
                                    </Checkbox>
                                </Col>
                            ))}</Row>
                        </div>
                        {/* --- MODIFICATION: Added compact margin to Divider --- */}
                        <Divider style={{ margin: '8px 0' }} />
                        <div>
                            {/* --- MODIFICATION: Removed top margin from Title --- */}
                            <Title level={5} style={{ marginTop: 0 }}>Assessment Tools</Title>
                            <Row gutter={[8, 16]}>{assessment.map((item) => (
                                <Col xs={24} sm={12} md={8} key={item.value}>
                                    <Checkbox value={item.value}>
                                        <Space>{getIcon(item.icon)}{item.label}</Space>
                                    </Checkbox>
                                </Col>
                            ))}</Row>
                        </div>
                    </Space>
                </Checkbox.Group>
            </Form.Item>

            <Divider />
            <Title level={5}><ToolOutlined /> Delivery & Focus</Title>
            <Form.Item label="Primary Delivery Mode" name="classroomFormat" rules={[{ required: true }]}>
                <Radio.Group optionType="button" buttonStyle="solid" style={{ width: '100%' }}>
                    <Row gutter={[12, 12]}>{classroomFormat.map((mode) => (
                        <Col xs={24} sm={12} key={mode.value}>
                            <Radio.Button value={mode.value} style={{ width: '100%' }}><Space>{getIcon(mode.icon)}{mode.label}</Space></Radio.Button>
                        </Col>
                    ))}
                    </Row>
                </Radio.Group>
            </Form.Item>

            <Form.Item label="What resources are available in the classroom?" name="resourceProfile" rules={[{ required: true }]}>
                <Radio.Group optionType="button" buttonStyle="solid" style={{ width: '100%' }}>
                    <Row gutter={[12, 12]}>{classroomResources.map((item) => (
                        <Col xs={24} sm={12} key={item.value}>
                            <Radio.Button value={item.value} style={{ width: '100%' }} disabled={isOnlineMode && item.value !== 'devices_1_to_1'}>
                                <Space>{getIcon(item.icon)}{item.label}</Space>
                            </Radio.Button>
                        </Col>
                    ))}
                    </Row>
                </Radio.Group>
                {isOnlineMode && <Text type="secondary" style={{ marginTop: '8px', display: 'block' }}>1-to-1 Devices are required for online lessons.</Text>}
            </Form.Item>

            <Form.Item label="How will you primarily assess learning?" name="assessmentFitCategory" rules={[{ required: true }]}>
                <Radio.Group optionType="button" buttonStyle="solid" style={{ width: '100%' }}>
                    <Row gutter={[12, 12]}>{assessmentOptions.map((item) => (
                        <Col xs={24} sm={12} key={item.value}>
                            <Radio.Button value={item.value} style={{ width: '100%' }}><Space>{getIcon(item.icon)}{item.label}</Space></Radio.Button>
                        </Col>
                    ))}
                    </Row>
                </Radio.Group>
            </Form.Item>

            <Form.Item label={(<Space><HeartOutlined />Student Well-being Focus (Optional)</Space>)} name="wellBeingFocus">
                <Radio.Group optionType="button" buttonStyle="solid" style={{ width: '100%' }}>
                    <Row gutter={[12, 12]}>
                        {wellBeingOptions.map((item) => (
                            <Col xs={24} sm={12} key={item.value}>
                                <Radio.Button value={item.value} style={{ width: '100%' }}>
                                    <Space>{getIcon(item.icon)}{item.label}</Space>
                                </Radio.Button>
                            </Col>
                        ))}
                    </Row>
                </Radio.Group>
            </Form.Item>

            <Form.Item
                label="Teacher's Note / Custom Instructions (Optional)"
                name="customInstructions"
                tooltip={{ title: "Guide the AI with specific needs or interests.", icon: <InfoCircleOutlined /> }}
            >
                <TextArea rows={4} placeholder="e.g., 'Please ensure the examples are related to sports statistics.'" />
            </Form.Item>
        </Space>
    );
};

export default ResourcesCustomization;